import { api } from '../lib/gapApi';

export const runAgents = async (analysisId) => {
  const response = await api.post(`/analysis/${analysisId}/run-agents`);
  return response.data;
};

export const getAgentReports = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/agent-reports`);
  return response.data;
};

export const getFinalReport = async (analysisId) => {
  const response = await api.get(`/analysis/${analysisId}/final-report`);
  return response.data;
};
